import React, { createContext } from 'react';

import { extraFieldsType } from '../types';

export interface IContext {
    nameList: string;
    prefixStore: string;
    extraFields?: extraFieldsType[];
}

export const SmxPropsContext = createContext<IContext>({
    nameList: '',
    prefixStore: '',
    extraFields: [],
});

interface IPropsProvider extends IContext {
    children: React.ReactNode;
}

const PropsProvider: React.FC<IPropsProvider> = ({ prefixStore, nameList, extraFields, children }) => {
    return (
        <SmxPropsContext.Provider value={{ nameList, prefixStore, extraFields }}>{children}</SmxPropsContext.Provider>
    );
};

export default PropsProvider;
